(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-modal"] = factory(require("vue"));
	else
		root["vue-modal"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__203__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 454:
/***/ ((module) => {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"closePopup":"Close modal window"},"hu":{"closePopup":"Felugró ablak bezárása"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ 236:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(467);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(715);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.modal-open[data-v-57b2d6f1]{overflow:hidden}.sf-modal[data-v-57b2d6f1]{z-index:10491}.sf-modal--open[data-v-57b2d6f1]{overflow-y:auto}.sf-modal[data-v-57b2d6f1],.sf-modal-overlay[data-v-57b2d6f1]{position:fixed;bottom:0;left:0;right:0;top:0}.sf-modal-overlay[data-v-57b2d6f1]{opacity:.5;z-index:9998}.sf-modal-overlay--light[data-v-57b2d6f1]{opacity:.3}.sf-modal-overlay--dark[data-v-57b2d6f1]{opacity:.7}@media(min-width:768px){.sf-modal-dialog[data-v-57b2d6f1]{margin:auto;position:relative;width:528px}.sf-modal-dialog--default[data-v-57b2d6f1]{width:528px}}@media(min-width:996px){.sf-modal-dialog--default[data-v-57b2d6f1]{width:800px}}@media(min-width:768px){.sf-modal-dialog--narrow[data-v-57b2d6f1]{width:408px}}@media(min-width:996px){.sf-modal-dialog--narrow[data-v-57b2d6f1]{width:608px}}@media(min-width:768px){.sf-modal-dialog--wide[data-v-57b2d6f1]{width:648px}}@media(min-width:996px){.sf-modal-dialog--wide[data-v-57b2d6f1]{width:992px}}.sf-modal-content[data-v-57b2d6f1]{box-sizing:border-box;min-height:100vh;padding:16px 24px;position:inherit;bottom:0;left:0;right:0;top:0}@media(min-width:768px){.sf-modal-content[data-v-57b2d6f1]{border-radius:32px;box-sizing:content-box;height:inherit;margin:0 auto;max-width:inherit;min-height:0;padding:40px 32px;pointer-events:all;width:inherit}.sf-modal-content--columns[data-v-57b2d6f1]{padding:0}}.sf-modal-content--columns .sf-modal-heading[data-v-57b2d6f1]{left:32px;margin-bottom:0;min-height:40px;position:absolute;top:40px;width:80%}.sf-modal-content--white[data-v-57b2d6f1]{background-color:#fff}.sf-modal-content--gray[data-v-57b2d6f1]{background-color:#eceff6}.sf-modal__header[data-v-57b2d6f1]{display:flex;padding-right:60px;position:relative}.sf-modal-heading[data-v-57b2d6f1]{width:100%}.sf-modal__body[data-v-57b2d6f1]>:last-child{margin-bottom:0}@media(max-width:767px){.sf-modal__body--mobile-wide[data-v-57b2d6f1]{margin:0 -16px}}.sf-modal__footer[data-v-57b2d6f1]{margin-top:32px}.sf-modal__close-btn[data-v-57b2d6f1]{align-self:center;background-color:#fff;border:none;border-radius:50%;box-sizing:border-box;cursor:pointer;display:block;height:48px;padding:0;position:absolute;right:-16px;top:-8px;transition:.2s ease;width:48px;z-index:10;box-shadow:0 4px 8px rgba(73,92,136,.15)}@media(min-width:768px){.sf-modal__close-btn[data-v-57b2d6f1]{top:-24px}}@media(min-width:996px){.sf-modal__close-btn[data-v-57b2d6f1]{right:0;top:-8px}}.sf-modal__close-btn[data-v-57b2d6f1]:hover{background-color:#f6f7fa;transition:.2s ease}.sf-modal__close-btn[data-v-57b2d6f1]:active{background-color:inherit;box-shadow:none;transition:.2s ease}.sf-modal__close-btn[data-v-57b2d6f1]:focus{outline:2px solid #6fb4d8;outline-offset:3px}.sf-modal__close-btn[data-v-57b2d6f1]:focus:not(.focus-visible),.sf-modal__close-btn[data-v-57b2d6f1]:focus:not(:focus-visible){outline:none}.sf-modal__close-btn.focus-visible[data-v-57b2d6f1],.sf-modal__close-btn[data-v-57b2d6f1]:focus-visible{outline:2px solid #6fb4d8;outline-offset:3px}.sf-modal__close-btn svg[data-v-57b2d6f1]{height:16px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:16px}@media(max-width:767px){.sf-modal-content--columns .sf-modal__close-btn[data-v-57b2d6f1]{top:-8px;right:-16px}}@media(min-width:768px){.sf-modal-content--columns .sf-modal__close-btn[data-v-57b2d6f1]{top:16px;right:16px}}@media(min-width:996px){.sf-modal-content--columns .sf-modal__close-btn[data-v-57b2d6f1]{top:32px;right:32px}}@media(min-width:768px){.sf-modal__body--columns[data-v-57b2d6f1]{padding:24px}}@media(min-width:996px){.sf-modal__body--columns[data-v-57b2d6f1]{display:flex;padding:8px 8px 32px 32px}.sf-modal__column-wide[data-v-57b2d6f1]{flex:1;padding-right:32px;padding-top:32px}}.sf-modal__column-narrow[data-v-57b2d6f1]{background:#eceff6;border-radius:24px;display:none;position:relative;z-index:1}@media(min-width:996px){.sf-modal__column-narrow[data-v-57b2d6f1]{align-items:center;display:flex;flex:1;max-width:280px}.sf-modal__column-narrow[data-v-57b2d6f1]:after{background:#eceff6;border-bottom-left-radius:24px;border-bottom-right-radius:24px;bottom:-22px;content:"";display:block;height:40px;position:absolute;width:100%}}@media(min-width:768px){.sf-vertical-alignment-helper[data-v-57b2d6f1]{display:table;height:100%;pointer-events:none}.sf-vertical-align-center[data-v-57b2d6f1]{display:table-cell;max-width:inherit;padding:32px 0;pointer-events:none;vertical-align:middle;width:inherit}}`, ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 715:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 467:
/***/ ((module) => {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 383:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

 /*! 
  * portal-vue © Thorsten Lünborg, 2019 
  * 
  * Version: 2.1.7
  * 
  * LICENCE: MIT 
  * 
  * https://github.com/linusborg/portal-vue
  * 
 */



__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__(203));

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var inBrowser = typeof window !== 'undefined';
function freeze(item) {
  if (Array.isArray(item) || _typeof(item) === 'object') {
    return Object.freeze(item);
  }

  return item;
}
function combinePassengers(transports) {
  var slotProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return transports.reduce(function (passengers, transport) {
    var temp = transport.passengers[0];
    var newPassengers = typeof temp === 'function' ? temp(slotProps) : transport.passengers;
    return passengers.concat(newPassengers);
  }, []);
}
function stableSort(array, compareFn) {
  return array.map(function (v, idx) {
    return [idx, v];
  }).sort(function (a, b) {
    return compareFn(a[1], b[1]) || a[0] - b[0];
  }).map(function (c) {
    return c[1];
  });
}
function pick(obj, keys) {
  return keys.reduce(function (acc, key) {
    if (obj.hasOwnProperty(key)) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

var transports = {};
var targets = {};
var sources = {};
var Wormhole = Vue.extend({
  data: function data() {
    return {
      transports: transports,
      targets: targets,
      sources: sources,
      trackInstances: inBrowser
    };
  },
  methods: {
    open: function open(transport) {
      if (!inBrowser) return;
      var to = transport.to,
          from = transport.from,
          passengers = transport.passengers,
          _transport$order = transport.order,
          order = _transport$order === void 0 ? Infinity : _transport$order;
      if (!to || !from || !passengers) return;
      var newTransport = {
        to: to,
        from: from,
        passengers: freeze(passengers),
        order: order
      };
      var keys = Object.keys(this.transports);

      if (keys.indexOf(to) === -1) {
        Vue.set(this.transports, to, []);
      }

      var currentIndex = this.$_getTransportIndex(newTransport); // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays

      var newTransports = this.transports[to].slice(0);

      if (currentIndex === -1) {
        newTransports.push(newTransport);
      } else {
        newTransports[currentIndex] = newTransport;
      }

      this.transports[to] = stableSort(newTransports, function (a, b) {
        return a.order - b.order;
      });
    },
    close: function close(transport) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var to = transport.to,
          from = transport.from;
      if (!to || !from && force === false) return;

      if (!this.transports[to]) {
        return;
      }

      if (force) {
        this.transports[to] = [];
      } else {
        var index = this.$_getTransportIndex(transport);

        if (index >= 0) {
          // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays
          var newTransports = this.transports[to].slice(0);
          newTransports.splice(index, 1);
          this.transports[to] = newTransports;
        }
      }
    },
    registerTarget: function registerTarget(target, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.targets[target]) {
        console.warn("[portal-vue]: Target ".concat(target, " already exists"));
      }

      this.$set(this.targets, target, Object.freeze([vm]));
    },
    unregisterTarget: function unregisterTarget(target) {
      this.$delete(this.targets, target);
    },
    registerSource: function registerSource(source, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.sources[source]) {
        console.warn("[portal-vue]: source ".concat(source, " already exists"));
      }

      this.$set(this.sources, source, Object.freeze([vm]));
    },
    unregisterSource: function unregisterSource(source) {
      this.$delete(this.sources, source);
    },
    hasTarget: function hasTarget(to) {
      return !!(this.targets[to] && this.targets[to][0]);
    },
    hasSource: function hasSource(to) {
      return !!(this.sources[to] && this.sources[to][0]);
    },
    hasContentFor: function hasContentFor(to) {
      return !!this.transports[to] && !!this.transports[to].length;
    },
    // Internal
    $_getTransportIndex: function $_getTransportIndex(_ref) {
      var to = _ref.to,
          from = _ref.from;

      for (var i in this.transports[to]) {
        if (this.transports[to][i].from === from) {
          return +i;
        }
      }

      return -1;
    }
  }
});
var wormhole = new Wormhole(transports);

var _id = 1;
var Portal = Vue.extend({
  name: 'portal',
  props: {
    disabled: {
      type: Boolean
    },
    name: {
      type: String,
      default: function _default() {
        return String(_id++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerSource(_this.name, _this);
    });
  },
  mounted: function mounted() {
    if (!this.disabled) {
      this.sendUpdate();
    }
  },
  updated: function updated() {
    if (this.disabled) {
      this.clear();
    } else {
      this.sendUpdate();
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterSource(this.name);
    this.clear();
  },
  watch: {
    to: function to(newValue, oldValue) {
      oldValue && oldValue !== newValue && this.clear(oldValue);
      this.sendUpdate();
    }
  },
  methods: {
    clear: function clear(target) {
      var closer = {
        from: this.name,
        to: target || this.to
      };
      wormhole.close(closer);
    },
    normalizeSlots: function normalizeSlots() {
      return this.$scopedSlots.default ? [this.$scopedSlots.default] : this.$slots.default;
    },
    normalizeOwnChildren: function normalizeOwnChildren(children) {
      return typeof children === 'function' ? children(this.slotProps) : children;
    },
    sendUpdate: function sendUpdate() {
      var slotContent = this.normalizeSlots();

      if (slotContent) {
        var transport = {
          from: this.name,
          to: this.to,
          passengers: _toConsumableArray(slotContent),
          order: this.order
        };
        wormhole.open(transport);
      } else {
        this.clear();
      }
    }
  },
  render: function render(h) {
    var children = this.$slots.default || this.$scopedSlots.default || [];
    var Tag = this.tag;

    if (children && this.disabled) {
      return children.length <= 1 && this.slim ? this.normalizeOwnChildren(children)[0] : h(Tag, [this.normalizeOwnChildren(children)]);
    } else {
      return this.slim ? h() : h(Tag, {
        class: {
          'v-portal': true
        },
        style: {
          display: 'none'
        },
        key: 'v-portal-placeholder'
      });
    }
  }
});

var PortalTarget = Vue.extend({
  name: 'portalTarget',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    slim: {
      type: Boolean,
      default: false
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  data: function data() {
    return {
      transports: wormhole.transports,
      firstRender: true
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerTarget(_this.name, _this);
    });
  },
  watch: {
    ownTransports: function ownTransports() {
      this.$emit('change', this.children().length > 0);
    },
    name: function name(newVal, oldVal) {
      /**
       * TODO
       * This should warn as well ...
       */
      wormhole.unregisterTarget(oldVal);
      wormhole.registerTarget(newVal, this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.transition) {
      this.$nextTick(function () {
        // only when we have a transition, because it causes a re-render
        _this2.firstRender = false;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterTarget(this.name);
  },
  computed: {
    ownTransports: function ownTransports() {
      var transports = this.transports[this.name] || [];

      if (this.multiple) {
        return transports;
      }

      return transports.length === 0 ? [] : [transports[transports.length - 1]];
    },
    passengers: function passengers() {
      return combinePassengers(this.ownTransports, this.slotProps);
    }
  },
  methods: {
    // can't be a computed prop because it has to "react" to $slot changes.
    children: function children() {
      return this.passengers.length !== 0 ? this.passengers : this.$scopedSlots.default ? this.$scopedSlots.default(this.slotProps) : this.$slots.default || [];
    },
    // can't be a computed prop because it has to "react" to this.children().
    noWrapper: function noWrapper() {
      var noWrapper = this.slim && !this.transition;

      if (noWrapper && this.children().length > 1) {
        console.warn('[portal-vue]: PortalTarget with `slim` option received more than one child element.');
      }

      return noWrapper;
    }
  },
  render: function render(h) {
    var noWrapper = this.noWrapper();
    var children = this.children();
    var Tag = this.transition || this.tag;
    return noWrapper ? children[0] : this.slim && !Tag ? h() : h(Tag, {
      props: {
        // if we have a transition component, pass the tag if it exists
        tag: this.transition && this.tag ? this.tag : undefined
      },
      class: {
        'vue-portal-target': true
      }
    }, children);
  }
});

var _id$1 = 0;
var portalProps = ['disabled', 'name', 'order', 'slim', 'slotProps', 'tag', 'to'];
var targetProps = ['multiple', 'transition'];
var MountingPortal = Vue.extend({
  name: 'MountingPortal',
  inheritAttrs: false,
  props: {
    append: {
      type: [Boolean, String]
    },
    bail: {
      type: Boolean
    },
    mountTo: {
      type: String,
      required: true
    },
    // Portal
    disabled: {
      type: Boolean
    },
    // name for the portal
    name: {
      type: String,
      default: function _default() {
        return 'mounted_' + String(_id$1++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    // name for the target
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    },
    // Target
    multiple: {
      type: Boolean,
      default: false
    },
    targetSlim: {
      type: Boolean
    },
    targetSlotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    targetTag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  created: function created() {
    if (typeof document === 'undefined') return;
    var el = document.querySelector(this.mountTo);

    if (!el) {
      console.error("[portal-vue]: Mount Point '".concat(this.mountTo, "' not found in document"));
      return;
    }

    var props = this.$props; // Target already exists

    if (wormhole.targets[props.name]) {
      if (props.bail) {
        console.warn("[portal-vue]: Target ".concat(props.name, " is already mounted.\n        Aborting because 'bail: true' is set"));
      } else {
        this.portalTarget = wormhole.targets[props.name];
      }

      return;
    }

    var append = props.append;

    if (append) {
      var type = typeof append === 'string' ? append : 'DIV';
      var mountEl = document.createElement(type);
      el.appendChild(mountEl);
      el = mountEl;
    } // get props for target from $props
    // we have to rename a few of them


    var _props = pick(this.$props, targetProps);

    _props.slim = this.targetSlim;
    _props.tag = this.targetTag;
    _props.slotProps = this.targetSlotProps;
    _props.name = this.to;
    this.portalTarget = new PortalTarget({
      el: el,
      parent: this.$parent || this,
      propsData: _props
    });
  },
  beforeDestroy: function beforeDestroy() {
    var target = this.portalTarget;

    if (this.append) {
      var el = target.$el;
      el.parentNode.removeChild(el);
    }

    target.$destroy();
  },
  render: function render(h) {
    if (!this.portalTarget) {
      console.warn("[portal-vue] Target wasn't mounted");
      return h();
    } // if there's no "manual" scoped slot, so we create a <Portal> ourselves


    if (!this.$scopedSlots.manual) {
      var props = pick(this.$props, portalProps);
      return h(Portal, {
        props: props,
        attrs: this.$attrs,
        on: this.$listeners,
        scopedSlots: this.$scopedSlots
      }, this.$slots.default);
    } // else, we render the scoped slot


    var content = this.$scopedSlots.manual({
      to: this.to
    }); // if user used <template> for the scoped slot
    // content will be an array

    if (Array.isArray(content)) {
      content = content[0];
    }

    if (!content) return h();
    return content;
  }
});

function install(Vue$$1) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue$$1.component(options.portalName || 'Portal', Portal);
  Vue$$1.component(options.portalTargetName || 'PortalTarget', PortalTarget);
  Vue$$1.component(options.MountingPortalName || 'MountingPortal', MountingPortal);
}

var index = {
  install: install
};

__webpack_unused_export__ = index;
__webpack_unused_export__ = Portal;
__webpack_unused_export__ = PortalTarget;
exports.DS = MountingPortal;
__webpack_unused_export__ = wormhole;
//# sourceMappingURL=portal-vue.common.js.map


/***/ }),

/***/ 929:
/***/ ((module) => {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var regularTabbables = [];
  var orderedTabbables = [];

  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node) {
  if (
    !isNodeMatchingSelectorFocusable(node)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node);
}

function isNodeMatchingSelectorFocusable(node) {
  if (
    node.disabled
    || isHiddenInput(node)
    || isHidden(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

function isHidden(node) {
  // offsetParent being null will allow detecting cases where an element is invisible or inside an invisible element,
  // as long as the element does not use position: fixed. For them, their visibility has to be checked directly as well.
  return node.offsetParent === null || getComputedStyle(node).visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),

/***/ 50:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(236);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(514)/* ["default"] */ .Z)
var update = add("2fbe0116", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 514:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ addStylesClient)
});

;// CONCATENATED MODULE: ../../node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

;// CONCATENATED MODULE: ../../node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 203:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__203__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueModal.vue?vue&type=template&id=57b2d6f1&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MountingPortal',{attrs:{"mount-to":"body","append":"","multiple":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"sf-modal-frame",class:_vm.classes,attrs:{"role":_vm.role,"aria-modal":"true","aria-labelledby":"modal-title"}},[_c('div',{staticClass:"sf-modal-overlay",class:'sf-modal-overlay--' + _vm.overlayTheme,style:('background-color:' + _vm.overlayColor + ';')}),_c('div',{ref:"dialog",staticClass:"sf-modal",class:_vm.visible ? 'sf-modal--open' : '',attrs:{"id":_vm.modalId},on:{"click":function($event){if($event.target !== $event.currentTarget)return null;_vm.closable && _vm.clickOutsideClose && _vm.closePopup(true)}}},[_c('div',{staticClass:"sf-modal-dialog sf-vertical-alignment-helper",class:['sf-modal-dialog--' + _vm.modalWidth],attrs:{"role":"presentation"}},[_c('div',{staticClass:"sf-vertical-align-center"},[_c('FocusLoop',{attrs:{"is-visible":_vm.visible}},[_c('div',{staticClass:"sf-modal-content",class:[!_vm.customBackgroundColor ? 'sf-modal-content--' + _vm.backgroundColor : '', { 'sf-modal-content--columns': _vm.$slots['modal-column-wide'] && _vm.$slots['modal-column-narrow'] }]},[_c('div',{staticClass:"sf-modal__header"},[(_vm.hasHeader && _vm.headerVisible)?_c('div',{ref:"modal-header",staticClass:"sf-modal-heading",attrs:{"tabindex":"-1"}},[_vm._t("modal-header")],2):_vm._e(),(_vm.closable && _vm.closeBtnVisible)?_c('button',{staticClass:"sf-modal__close-btn",attrs:{"type":"button","aria-label":_vm.closePopupText ? _vm.closePopupText : _vm.$t('closePopup')},on:{"click":function($event){$event.preventDefault();return _vm.closePopup()}}},[_c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 20L20 4","stroke":"#52AE30","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M20 20L4 4","stroke":"#52AE30","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e()]),_c('div',{staticClass:"sf-modal__body",class:[{ 'sf-modal__body--columns': _vm.$slots['modal-column-wide'] && _vm.$slots['modal-column-narrow'] }, `sf-modal__body--mobile-${_vm.mobileBodyWidth}`]},[_vm._t("modal-body"),(_vm.$slots['modal-column-wide'])?_c('div',{staticClass:"sf-modal__column-wide"},[_vm._t("modal-column-wide")],2):_vm._e(),(_vm.$slots['modal-column-narrow'])?_c('div',{staticClass:"sf-modal__column-narrow"},[_vm._t("modal-column-narrow")],2):_vm._e()],2),(_vm.$slots['modal-footer'])?_c('div',{staticClass:"sf-modal__footer"},[_vm._t("modal-footer")],2):_vm._e()])])],1)])])])])
}
var staticRenderFns = []


// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(203);
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);
;// CONCATENATED MODULE: ./src/components/VueModal.EventBus.js

/* harmony default export */ const VueModal_EventBus = (new (external_commonjs_vue_commonjs2_vue_root_Vue_default())());

// EXTERNAL MODULE: ../../node_modules/tabbable/index.js
var tabbable = __webpack_require__(929);
var tabbable_default = /*#__PURE__*/__webpack_require__.n(tabbable);
;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue-a11y/focus-loop/dist/vue-focus-loop.esm.js
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var focusableElementsSelector = ['input', 'select', 'button', 'textarea'].map(function (field) { return (field + ":not([disabled])"); }).concat( ['a[href]'],
  ['video[controls]'],
  ['audio[controls]'],
  ['[tabindex]:not([tabindex^="-"])'],
  ['[contenteditable]:not([contenteditable="false"])']
).join(',');

var ariaHiddenElements = [];

var script = {
  name: 'FocusLoop',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: true
    }
  },

  data: function data () {
    return {
      alreadyFocused: false
    }
  },

  computed: {
    getTabindex: function getTabindex () {
      return this.disabled ? -1 : 0
    }
  },

  watch: {
    isVisible: 'init',
    disabled: 'init'
  },

  mounted: function mounted () {
    this.init();
  },

  methods: {
    init: function init () {
      var this$1 = this;

      this.$nextTick(function () {
        var active = this$1.isVisible && !this$1.disabled;
        !this$1.disabled && this$1.focusFirst(active && this$1.autoFocus);
        this$1.managePrevFocusElement(active);
        this$1.lockForSwipeScreenReader(active);
        if (!active) {
          ariaHiddenElements = [];
        }
      });
    },

    managePrevFocusElement: function managePrevFocusElement (active) {
      if (!active && window.vflPrevFocusedElement) {
        return window.vflPrevFocusedElement.focus()
      }
      window.vflPrevFocusedElement = document.activeElement;
    },

    getElementsToAriaHidden: function getElementsToAriaHidden (focusLoopContainer) {
      function getElements (element) {
        var children = Array.from(element.children);
        children.forEach(function (el) {
          if (el === focusLoopContainer) { return }
          if (!el.contains(focusLoopContainer)) {
            ariaHiddenElements.push(el);
            return
          }
          getElements(el);
        });
      }
      getElements(document.body);
    },

    lockForSwipeScreenReader: function lockForSwipeScreenReader (active) {
      if ( active === void 0 ) active = true;

      if (active) { this.getElementsToAriaHidden(this.$refs.VuefocusLoopContainer); }
      ariaHiddenElements.forEach(function (el) {
        if (['SCRIPT', 'STYLE'].includes(el.nodeName) || el.hasAttribute('aria-live')) { return }
        el.setAttribute('aria-hidden', active.toString());
      });
    },

    focusFirst: function focusFirst (isAutoFocus) {
      if (isAutoFocus) {
        var elements = this.getFocusableElements();
        if (elements.length) { setTimeout(function () { return elements[0].focus(); }, 200); }
      }
    },

    getFocusableElements: function getFocusableElements () {
      var focusableElements = this.$refs.focusLoop.querySelectorAll(focusableElementsSelector);
      if (focusableElements && focusableElements.length) { return focusableElements }
      return []
    },

    handleFocusStart: function handleFocusStart () {
      var elements = this.getFocusableElements();
      if (elements.length) {
        var index = this.alreadyFocused ? elements.length - 1 : 0;
        this.alreadyFocused = true;
        elements[index].focus();
      }
    },

    handleFocusEnd: function handleFocusEnd () {
      var elements = this.getFocusableElements();
      elements.length && elements[0].focus();
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{ref:"VuefocusLoopContainer",staticClass:"vue-focus-loop"},[_c('div',{attrs:{"tabindex":_vm.getTabindex,"aria-hidden":"true"},on:{"focus":_vm.handleFocusStart}}),_vm._v(" "),_c('div',{ref:"focusLoop"},[_vm._t("default")],2),_vm._v(" "),_c('div',{attrs:{"tabindex":_vm.getTabindex,"aria-hidden":"true"},on:{"focus":_vm.handleFocusEnd}})]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

function install (Vue) {
  if (install.installed) { return }
  install.installed = true;
  Vue.component('FocusLoop', __vue_component__);
}

// auto install
if (typeof window !== 'undefined' && typeof window.Vue !== 'undefined') {
  window.Vue.use(install);
}

/* harmony default export */ const vue_focus_loop_esm = ((/* unused pure expression or super */ null && (install)));


// EXTERNAL MODULE: ../../node_modules/portal-vue/dist/portal-vue.common.js
var portal_vue_common = __webpack_require__(383);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueModal.vue?vue&type=script&lang=js&







const WIDTH = ['default', 'narrow', 'wide'];
const OVERLAY_THEME = ['default', 'dark', 'light'];
const DEFAULT_OVERLAY_COLOR = '#000000';
const BACKGROUND_COLOR = ['white', 'gray'];
const ROLES = ['document', 'dialog'];
const MOBILE_BODY_WIDTH = ['default', 'wide'];

/* harmony default export */ const VueModalvue_type_script_lang_js_ = ({
	name: 'VueModal',
	data() {
		return {
			visible: false,
			modalWidth: null,
			returnFocusToElement: null,
			parentModuleText: null,
			payload: null,
			headerVisible: true,
			scrollbarWidth: null
		};
	},
	props: {
		/**
		 * Id of the modal
		 */
		modalId: {
			required: true,
			type: String,
			validator(val) {
				return !/\s/.test(val);
			}
		},
		/**
		 * Width of the modal
		 */
		width: {
			required: false,
			default: WIDTH[0],
			validator(val) {
				return WIDTH.includes(val);
			}
		},
		/**
		 * Color of the overlay layer
		 */
		overlayColor: {
			required: false,
			type: String,
			default: DEFAULT_OVERLAY_COLOR,
			validator(val) {
				return t.HEX.test(val);
			}
		},
		/**
		 * Specify the opacity of the overlay layer
		 */
		overlayTheme: {
			required: false,
			type: String,
			default: OVERLAY_THEME[0],
			validator(val) {
				return OVERLAY_THEME.includes(val);
			}
		},
		/**
		 * Specify the background color of the modal
		 */
		backgroundColor: {
			required: false,
			type: String,
			default: BACKGROUND_COLOR[0],
			validator(val) {
				return BACKGROUND_COLOR.includes(val);
			}
		},
		/**
		 * Specify the background color of the modal in hexa
		 */
		customBackgroundColor: {
			required: false,
			type: String,
			validator(val) {
				return t.HEX.test(val);
			}
		},
		/**
		 * Specify the role type of the dialog for accessibility reason
		 */
		role: {
			required: false,
			type: String,
			default: ROLES[0],
			validator(val) {
				return ROLES.includes(val);
			}
		},
		/**
		 * Specify the mobile width of the modal
		 */
		mobileBodyWidth: {
			required: false,
			type: String,
			default: MOBILE_BODY_WIDTH[0],
			validator(val) {
				return MOBILE_BODY_WIDTH.includes(val);
			}
		},
		/**
		 * Specify whether the modal is open or not
		 */
		open: {
			required: false,
			default: false
		},
		/**
		 * Specify whether the modal is closable or not
		 */
		closable: {
			required: false,
			default: true
		},
		clickOutsideClose: {
			required: false,
			default: true
		},
		/**
		 * Hides close button
		 */
		closeBtnVisible: {
			required: false,
			default: true
		},
		/**
		 * Overrides the aria-label of the close button
		 */
		closePopupText: {
			type: String,
			required: false
		},

		classes: {
			type: String,
			required: false
		}
	},
	components: {
		FocusLoop: __vue_component__,
		MountingPortal: portal_vue_common/* MountingPortal */.DS
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		hasHeader() {
			return !!this.$slots['modal-header'];
		}
	},
	methods: {
		closePopup(clickOutSide = false) {
			this.visible = false;
			VueModal_EventBus.$emit('toggle-inert', this.visible);
			VueModal_EventBus.$emit('modal-closed', this.modalId);
			(window.dataLayer || []).push({
				event: 'modalClosed'
			});
			if (clickOutSide) {
				VueModal_EventBus.$emit('modal-click-outside', this.modalId);
			}
			document.body.classList.remove('modal-open');
			document.body.removeAttribute('style');
			this.$nextTick(() => {
				this.returnFocusToElement && this.returnFocusToElement.focus();
			});
		},
		async openPopup() {
			VueModal_EventBus.$emit('modal-opened', this.modalId, this.payload);
			document.body.classList.add('modal-open');
			document.body.style.paddingRight = this.scrollbarWidth + 'px';
			await this.$nextTick();
			this.visible = true;
			VueModal_EventBus.$emit('toggle-inert', this.visible);
		},

		keyHandler(e) {
			if (this.visible && e.which == 27) {
				this.closable && this.closePopup();
			}
		},
		openModal(e, modalId, options) {
			if (modalId == this.modalId) {
				if (options && options.payload) {
					this.payload = options.payload;
				}
				this.returnFocusToElement = e.target;
				this.openPopup();
				if (options && options.scrollId) {
					this.$nextTick(() => {
						let elem = document.getElementById(options.scrollId);
						if (elem) {
							this.$scrollTo(elem, { duration: 500, container: '.modal', offset: options.offset || 0 });
						}
					});
				}
				// GA kuldeshez kell tudni melyik moduleban vagyunk
				if (options && options.parentModuleText) {
					this.parentModuleText = options.parentModuleText;
				}
			}
		},
		closeModal(modalId) {
			if (modalId == this.modalId) {
				if (this.visible) {
					this.closePopup();
				}
			}
		},
		changeModalWidth(modalId, modalWidth) {
			if (modalId == this.modalId) {
				this.modalWidth = modalWidth;
			}
		},
		hideHeader(modalId) {
			if (modalId == this.modalId) {
				this.headerVisible = false;
			}
		},
		showHeader(modalId) {
			if (modalId == this.modalId) {
				this.headerVisible = true;
			}
		},
		changeHeader(modalId, modalHeader) {
			if (modalId == this.modalId) {
				const header = this.$refs['modal-header'];
				if (header?.childNodes.length == 1) {
					const childNode = header.firstChild;
					if (childNode.nodeType == Node.TEXT_NODE) {
						childNode.textContent = modalHeader;
					} else if (childNode.nodeType == Node.ELEMENT_NODE && childNode.childNodes.length == 1 && !childNode.firstChild.firstChild) {
						childNode.firstChild.textContent = modalHeader;
					}
				}
			}
		},
		focusTop(modalId) {
			if (modalId == this.modalId) {
				this.$nextTick(() => {
					const allTabbableElements = tabbable_default()(this.$el);
					if (allTabbableElements.length) {
						allTabbableElements[0].focus();
					}
				});
			}
		}
	},
	watch: {
		width: {
			handler(val) {
				this.modalWidth = val;
			},
			immediate: true
		}
	},
	mounted() {
		window.addEventListener('keyup', this.keyHandler);
		VueModal_EventBus.$on('open-modal', this.openModal);
		VueModal_EventBus.$on('close-modal', this.closeModal);
		VueModal_EventBus.$on('change-modal-width', this.changeModalWidth);
		VueModal_EventBus.$on('hide-header', this.hideHeader);
		VueModal_EventBus.$on('show-header', this.showHeader);
		VueModal_EventBus.$on('change-header', this.changeHeader);
		VueModal_EventBus.$on('focus-modal', this.focusTop);
		this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
	},
	beforeDestroy() {
		window.removeEventListener('keyup', this.keyHandler);
		VueModal_EventBus.$off('open-modal', this.openModal);
		VueModal_EventBus.$off('close-modal', this.closeModal);
		VueModal_EventBus.$off('change-modal-width', this.changeModalWidth);
		VueModal_EventBus.$off('hide-header', this.hideHeader);
		VueModal_EventBus.$off('show-header', this.showHeader);
		VueModal_EventBus.$off('change-header', this.changeHeader);
		VueModal_EventBus.$off('focus-modal', this.focusTop);
	},
	created() {
		this.open && this.openPopup();
	}
});

;// CONCATENATED MODULE: ./src/components/VueModal.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueModalvue_type_script_lang_js_ = (VueModalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../../node_modules/vue-style-loader/index.js??clonedRuleSet-63.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-63.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[2]!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-63.use[3]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-63.use[4]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueModal.vue?vue&type=style&index=0&id=57b2d6f1&prod&scoped=true&lang=scss&
var VueModalvue_type_style_index_0_id_57b2d6f1_prod_scoped_true_lang_scss_ = __webpack_require__(50);
;// CONCATENATED MODULE: ./src/components/VueModal.vue?vue&type=style&index=0&id=57b2d6f1&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function componentNormalizer_normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// EXTERNAL MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueModal.vue?vue&type=custom&index=0&blockType=i18n
var VueModalvue_type_custom_index_0_blockType_i18n = __webpack_require__(454);
var VueModalvue_type_custom_index_0_blockType_i18n_default = /*#__PURE__*/__webpack_require__.n(VueModalvue_type_custom_index_0_blockType_i18n);
;// CONCATENATED MODULE: ./src/components/VueModal.vue?vue&type=custom&index=0&blockType=i18n
 /* harmony default export */ const components_VueModalvue_type_custom_index_0_blockType_i18n = ((VueModalvue_type_custom_index_0_blockType_i18n_default())); 
;// CONCATENATED MODULE: ./src/components/VueModal.vue



;


/* normalize component */

var component = componentNormalizer_normalizeComponent(
  components_VueModalvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "57b2d6f1",
  null
  
)

/* custom blocks */
;
if (typeof components_VueModalvue_type_custom_index_0_blockType_i18n === 'function') components_VueModalvue_type_custom_index_0_blockType_i18n(component)

/* harmony default export */ const VueModal = (component.exports);
;// CONCATENATED MODULE: ./src/components/VueModal.plugin.js



/* harmony default export */ const VueModal_plugin = ({
	install(Vue) {
		Vue.component('VueModal', VueModal);
		Vue.prototype.$openModal = Vue.openModal = (e, id, modalOptions) => {
			VueModal_EventBus.$emit('open-modal', e, id, modalOptions);
		};
		Vue.prototype.$closeModal = Vue.closeModal = (id) => {
			VueModal_EventBus.$emit('close-modal', id);
		};
		Vue.prototype.$showModalHeader = Vue.showModalHeader = (id) => {
			VueModal_EventBus.$emit('show-header', id);
		};
		Vue.prototype.$hideModalHeader = Vue.hideModalHeader = (id) => {
			VueModal_EventBus.$emit('hide-header', id);
		};
		Vue.prototype.$changeModalHeader = Vue.changeModalHeader = (id, modalHeader) => {
			VueModal_EventBus.$emit('change-header', id, modalHeader);
		};
		Vue.prototype.$changeModalWidth = Vue.changeModalWidth = (modalId, modalWidth) => {
			VueModal_EventBus.$emit('change-modal-width', modalId, modalWidth);
		};
		Vue.prototype.$focusModalTop = Vue.focusTop = (id) => {
			VueModal_EventBus.$emit('focus-modal', id);
		};
		Vue.prototype.$modalEventBus = Vue.modalEventBus = VueModal_EventBus;
	}
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueModal_plugin);


})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-modal.umd.js.map